<template>
  <div class="guest-list">
    <div class="guest-inner">
      <div class="guest-item">
        <div class="guest-titles slidetop" data-scroll data-scroll-call="animateMove">
          <strong>出品人</strong>
          <small data-scroll data-scroll-speed="-1" data-scroll-direction="horizontal">publisher</small>
        </div>
        <ul class="guest-li">
          <li v-for="item in publisher.slice(0,cun1)" :key="item.id" class="slidetop" data-scroll data-scroll-call="animateMove" @click="guestview(item)">
            <figure><i></i><img :src="item.face" alt=""/></figure>
            <div class="guest-info">
              <strong v-html="item.user"></strong>
              <p v-html="item.title"></p>
            </div>
          </li>
        </ul>
        <div class="guest-more" @click="openMore1" v-show="publisherShow">
          <span>查看更多</span>
          <svg t="1661156947684" class="icon" viewBox="0 0 1024 1024" version="1.1"><path d="M483.072 714.496l30.165333 30.208 415.957334-415.829333a42.837333 42.837333 0 0 0 0-60.288 42.538667 42.538667 0 0 0-60.330667-0.042667l-355.541333 355.413333-355.242667-355.413333a42.496 42.496 0 0 0-60.288 0 42.837333 42.837333 0 0 0-0.085333 60.330667l383.701333 383.872 1.706667 1.749333z" p-id="2352"></path></svg>
        </div>
      </div>
      <div class="guest-item">
        <div class="guest-titles">
          <strong>嘉宾讲师</strong>
          <small data-scroll data-scroll-speed="-1" data-scroll-direction="horizontal">lecturer</small>
        </div>
        <ul class="guest-li">
          <li v-for="item in lecturer.slice(0,cun)" :key="item.id" class="slidetop" data-scroll data-scroll-call="animateMove" @click="guestview(item)">
            <figure><i></i><img :src="item.face" alt=""/></figure>
            <div class="guest-info">
              <strong v-html="item.user"></strong>
              <p v-html="item.title"></p>
            </div>
          </li>
        </ul>
        <div class="guest-more" @click="openMore" v-show="checkShow">
          <span>查看更多</span>
          <svg t="1661156947684" class="icon" viewBox="0 0 1024 1024" version="1.1"><path d="M483.072 714.496l30.165333 30.208 415.957334-415.829333a42.837333 42.837333 0 0 0 0-60.288 42.538667 42.538667 0 0 0-60.330667-0.042667l-355.541333 355.413333-355.242667-355.413333a42.496 42.496 0 0 0-60.288 0 42.837333 42.837333 0 0 0-0.085333 60.330667l383.701333 383.872 1.706667 1.749333z" p-id="2352"></path></svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isMobile: null,
      guests: [],
      publisher: [],
      lecturer: [],
      cun: 0,
      checkShow: true,
      cun1: 0,
      publisherShow: true
    }
  },
  props: {
    scroll: Object
  },
  methods: {
    async getGuest () {
      const { data: res } = await this.$http.get('/guests')
      this.guests = res.data
      console.log(this.guests)
      this.guests.forEach((item, index) => {
        if (item.tag === '出品人') {
          this.publisher.push(item)
        } else {
          this.lecturer.push(item)
        }
      })
      console.log(this.guests)
      if (this.cun >= this.lecturer.length) {
        this.checkShow = false
      }
      if (this.cun1 >= this.publisher.length) {
        this.publisherShow = false
      }
      setTimeout(() => {
        this.scroll.update()
      }, 400)
    },
    guestview (item) {
      this.$parent.$parent.setPopShow(item)
    },
    openMore () {
      this.cun = this.cun * 2
      if (this.cun >= this.lecturer.length) {
        this.checkShow = false
      }
      setTimeout(() => {
        this.scroll.update()
      }, 500)
    },
    openMore1 () {
      this.cun1 = this.cun1 * 2
      if (this.cun1 >= this.publisher.length) {
        this.publisherShow = false
      }
      setTimeout(() => {
        this.scroll.update()
      }, 500)
    }
  },
  computed: {
    splitname: function (value) {
      return value.split(' ')
    }
  },
  created () {
    this.isMobile = window.matchMedia('(max-width: 1024px)').matches
    if (this.isMobile) {
      this.cun = 8
      this.cun1 = 8
    } else {
      this.cun = 18
      this.cun1 = 18
    }
  },
  mounted () {
    this.getGuest()
  }
}
</script>

<style lang="less" scoped>
  @import url("@/assets/css/guest/index.less");
</style>